import React from 'react'
import { PieChartCardProps } from './interface'

export function withPieChartCard(Component: React.FC<PieChartCardProps>) {
  function WithPieChartCard(props: PieChartCardProps) {
    return <Component {...props} />
  }
  return WithPieChartCard
}
